var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{ true: '', false: _vm.sortDir }[_vm.sortBy !== _vm.sortValue],attrs:{"href":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.sort.apply(null, arguments)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }